import BaseAPI from '../base'

function getCampaigns() {
    return BaseAPI.get('referrals/campaigns');
}

function createCampaign(title, period_start, period_end) {
    return BaseAPI.post(`referrals/create`, {
        title,
        period_start,
        period_end
    });
}

function updateCampaign(id, title, period_start, period_end, force_mode) {
    return BaseAPI.post(`referrals/update/${id}`, {
        title,
        period_start,
        period_end,
        force_mode
    });
}

function removeCampaign(id) {
    return BaseAPI.post(`referrals/remove/${id}`);
}

export default {
    getCampaigns,
    createCampaign,
    updateCampaign,
    removeCampaign
}